import PaneMenuGroup from './PaneMenuGroup';

export default PaneMenuGroup;
export { PaneMenuGroup };
